import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const MAW_I18N_NAMESPACE = '@mc/enterprise-announcement'

export const i18nInstance = registerI18nResources({
  namespace: MAW_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
